import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Container, Row, Col, Input, Table, Button, Alert, Spinner } from 'reactstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import authService from '../api-authorization/AuthorizeService';
import AdminFunctions from './AdminFunctions';
import AuthFunctions from '../services/AuthService';
import Session from '../auth/Session'
import utilities from '../util/utilities';
import { FaSort } from 'react-icons/fa'


function Users() {
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState(null);
    const [clientOptions, setClientOptions] = useState([]);
    const [client, setClient] = useState(null);
    const [height, setHeight] = useState(0);
    const [width, setWidth] = useState(0);
    const [sort, setSort] = useState({
        column: null,
        direction: 'desc'
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function isAuth() {
            var _token = Session.getToken();
            var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
            if (!isAuthenticated) {
                navigate('/login');
            }
        }
        isAuth();
        async function fetchIsAdmin() {
            const isAdmin = await AdminFunctions.isAdminAsync();
            if (!isAdmin) {
                navigate('/accessdenied');
                return;
            }

            await getClientDropdown();
            await getUsers();
        }
        isAuth();
        fetchIsAdmin();
    }, [navigate]);

    const getClientDropdown = async () => {
        const token = Session.getToken();

        const response = await fetch(`api/Clients/GetDropdown`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        setClientOptions(data);
    };

    const getUsers = async () => {
        setLoading(true);
        const token = Session.getToken();

        const response = await fetch(`api/Admin/GetUsersAsync`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        setUsers(data);
        setLoading(false);
    };

    const searchUsers = async () => {
        setLoading(true);
        const token = Session.getToken();

        const response = await fetch(`api/Admin/SearchUsersAsync?query=${search || ''}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        setUsers(data);
        setLoading(false);
    };

    const handleRowClick = (userId) => {
        navigate('/admin/users/details', {
            state: { userId: userId, existingUser: true }
        });
    };

    return (
        <div>
            {error ? (
                <Row>
                    <Col>
                        <div className="alert alert-danger mb-0">{error}</div>
                    </Col>
                </Row>
            ) : null}
            <Container className='container-main'>
                <Row>
                    <Col>
                        <h3>Users</h3>
                    </Col>
                </Row>

                {/* Header / search */}
                <Row className="align-items-center g-3">
                    {/* Search input */}
                    <Col xs="12" md="6" className="d-flex gap-3">
                        <Input
                        type="text"
                        onChange={(e) => setSearch(e.target.value)}
                        name="search"
                        id="search"
                        placeholder="Search"
                        />
                        <Button
                                color="primary"
                                onClick={searchUsers}
                                className="flex-fill flex-md-grow-0 text-nowrap"
                            >
                                Search
                            </Button>
                    </Col>

                    {/* Buttons */}
                    <Col xs="12" md="auto">
                        <div className="d-flex gap-3 w-100">
                            <Button
                                color="primary"
                                onClick={() =>
                                navigate("/admin/users/details", {
                                    state: { existingUser: false },
                                })
                                }
                                className="flex-fill flex-md-grow-0 text-nowrap"
                            >
                                + Add
                            </Button>
                        </div>
                    </Col>
                </Row>

                {loading ? 
                    <div style={{marginTop: "2rem", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <Spinner />
                    </div> 
                    : 
                    <>
                        {/* Users table */}
                        <Row className='row-20'>
                            <Col>
                                <Table bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>User Level</th>
                                            <th>Name</th>
                                            <th>Username</th>
                                            {/* <th>Password</th> */}
                                            <th>Email</th>
                                            <th>Mobile Phone</th>
                                            <th>Alternate Phone</th>
                                            <th>Active</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users.map((user) => (
                                            <tr
                                                key={user.id}
                                                onClick={() => handleRowClick(user.id)}
                                                style={{cursor: "pointer"}}
                                            >
                                                <td>{user.role}</td>
                                                <td>{`${user.lastName}, ${user.firstName}`}</td>
                                                <td>{user.userName}</td>
                                                {/* <td>{user.password}</td> */}
                                                <td>{user.email}</td>
                                                <td>{user.mobilePhone}</td>
                                                <td>{user.alternatePhone}</td>
                                                <td><Input
                                                    type='checkbox'
                                                    disabled
                                                    checked={user.active}
                                                    name='active'
                                                /></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </>
                }
            </Container>
        </div>
    );
}

export default Users;